import { Typography, useMediaQuery, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

import { SummaryCardNew } from '@hapvida/hapvida-core-components';

import { MovimentationStepRouter } from '@flows/private/movements/pages/MovimentationSteps/router';
import { BillListRouter } from '@flows/private/financial/pages/List/router';
import { MOVIMENTATION_STEPS_KEYS } from 'constants/private/movements/newMovementSteps';
import { BeneficiaryListRouter } from '@flows/private/beneficiaries/pages/BeneficiaryList/router';
import { FEATURE_TOGGLE } from '@constants';

import QuickActionButton from './components/QuickActionButton';
import { HomeQuickActionsMobile } from './components/HomeQuickActionsMobile';
import { StyledStack } from './components/QuickActionButton/styles';
import { BeneficiariesRedirectModal } from './components/BeneficiariesRedirectModal';

export function HomeQuickActions() {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'), {
    noSsr: true,
  });

  const [openModalState, setOpenModalState] = useState(false);

  const toggleModal = () => {
    setOpenModalState(!openModalState);
  };

  const handleGoToBeneficiaries = () => {
    if (FEATURE_TOGGLE.BENEFICIARIES_V3) {
      navigate(BeneficiaryListRouter.path);
      return;
    }

    setOpenModalState(true);
  };

  const handleNewLayoutMovement = () => {
    navigate(
      MovimentationStepRouter.dynamicPath({
        movimentationStep: MOVIMENTATION_STEPS_KEYS?.MOVIMENTATION_FILE,
      }),
    );
  };

  const handleGoToBillList = () => {
    navigate(BillListRouter.path);
  };

  return (
    <>
      {isMobile ? (
        <HomeQuickActionsMobile />
      ) : (
        <SummaryCardNew.Container>
          <Typography variant="subtitle1">Ações rápidas</Typography>

          <StyledStack>
            <QuickActionButton
              onClick={handleGoToBeneficiaries}
              text="Lista de beneficiários"
              iconName="actions-b2b-account-multiple"
            />

            <QuickActionButton
              onClick={handleNewLayoutMovement}
              text="Movimentação via layout"
              iconName="actions-b2b-swap-vertical-circle"
            />

            <QuickActionButton
              onClick={handleGoToBillList}
              text="Extrato financeiro"
              iconName="actions-b2b-attach-money"
            />
          </StyledStack>
          <BeneficiariesRedirectModal
            openModal={openModalState}
            toggleModal={toggleModal}
          />
        </SummaryCardNew.Container>
      )}
    </>
  );
}
